<label #root class="root -size-{{ (data$ | async)!.size }}" [class.-disabled]="(data$ | async)!.disabled">
  <input
    class="input"
    type="checkbox"
    attr.data-qa-id="ds-checkbox-checked:{{ (data$ | async)!.checked }}"
    [attr.name]="name"
    [checked]="(data$ | async)!.checked"
    [indeterminate]="indeterminate"
    [disabled]="(data$ | async)!.disabled"
    (change)="changed()"
    (blur)="touched()"
  />

  <span class="checkbox"></span>

  <span class="label-text">
    <ng-content></ng-content>
  </span>
</label>
